import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import { CreateWorkflowTemplateForm } from '../forms/CreateWorkflowTemplateForm';

type TCreateWorkflowTemplateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (workflowTemplateVersionId: string) => void;
};

export const CreateWorkflowTemplateModal = ({
  isOpen,
  onClose,
  onSuccess,
}: TCreateWorkflowTemplateModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create workflow template</DialogTitle>
        </DialogHeader>
        <CreateWorkflowTemplateForm
          onSuccess={(workflowTemplateVersionId) =>
            onSuccess?.(workflowTemplateVersionId)
          }
          onCancel={onClose}
          formContentClassName="p-3xl"
          formFooterClassName="p-3xl"
        />
      </DialogContent>
    </Dialog>
  );
};
